'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
require('../Button/Button.js');
var IconButton = require('../Button/IconButton.js');
require('../Button/StatisticsButton.js');
var ColumnCard = require('./ColumnCard.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "children"];
/**
 * ColumnCardButton
 *
 * Displays an icon button; used for the download button or a custom one.
 */
var ColumnCardButton = react.forwardRef(function (props, ref) {
  var _CARD_TYPES$cardType;
  var className = props.className,
    children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useColumnCardContext = ColumnCard.useColumnCardContext(),
    cardType = _useColumnCardContext.cardType;
  var media = (_CARD_TYPES$cardType = ColumnCard.CARD_TYPES[cardType]) === null || _CARD_TYPES$cardType === void 0 ? void 0 : _CARD_TYPES$cardType.buttonIcon;
  var styles = react.useStyles();
  var Icon = media ? /*#__PURE__*/React__default["default"].createElement(media) : children;
  return /*#__PURE__*/React__default["default"].createElement(IconButton.IconButton, _extends__default["default"]({
    className: utils.cx('chakra-column-card__button', className),
    ref: ref
  }, styles.button, rest), Icon);
});
ColumnCardButton.displayName = 'ColumnCardButton';
exports.ColumnCardButton = ColumnCardButton;